/**
 * Field names for server-side sorting
 * These match the backend GraphQL schema sort field names
 */
export const INTENT_TABLE_SORT_FIELDS = {
  SIGNAL_STRENGTH: "score",
  TOPIC: "topic_display_name",
  BUYERS_JOURNEY: "buyers_journey_name",
  CONTEXT_TYPES: "context_aggregate_type_names",
  LOCATION: "location_state_country_name",
  LOCATION_STRENGTH: "location_score",
  DATESTAMP: "last_seen_at",
  URL: "url",
} as const;

/**
 * Default pagination settings for Intent table
 */
export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

/**
 * Default number of cadences (weeks) for intent data
 */
export const DEFAULT_NUMBER_OF_CADENCES = 6;

/**
 * Get human-readable label for number of cadences
 */
export function getCadenceLabel(numberOfCadences: number): string {
  if (numberOfCadences === 1) return "the past week";
  return `the past ${numberOfCadences} weeks`;
}
